import React from 'react';

const HeroSection: React.FC = () => {
  const [treesPlanted, setTreesPlanted] = React.useState<number>(50000);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('/api/stats');
        if (response.ok) {
          const data = await response.json();
          setTreesPlanted(data.treesPlanted);
        }
      } catch (error) {
        console.error('Failed to fetch stats:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchStats();
  }, []);

  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return `${Math.floor(num / 1000).toLocaleString()}k+`;
    }
    return num.toLocaleString();
  };

  const calculateHectares = (trees: number) => {
    const baseHectares = Math.floor(trees / 100);
    return baseHectares + 3;
  };

  const goToPlantTrees = () => {
    const contribute = document.getElementById('contribute');
    if (contribute) {
      contribute.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = '/plant-trees';
    }
  };

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-logo">
          <img
            src="/images/logo.jpg"
            alt="World Conserve - Restaurando los bosques de Colombia"
            className="hero-logo-img"
          />
        </div>
        <div className="hero-text">
          <h1 className="hero-title">Recupera los bosques</h1>
          <p className="hero-subtitle">Únete a nuestra misión de plantar árboles nativos, restaurar ecosistemas y combatir el cambio climático a través de esfuerzos de conservación transparentes.</p>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">
                {isLoading ? '...' : formatNumber(treesPlanted)}
              </div>
              <div className="stat-label">Árboles Plantados</div>
            </div>
            <div className="stat">
              <div className="stat-number">
                {isLoading ? '...' : `${calculateHectares(treesPlanted)}+`}
              </div>
              <div className="stat-label">Hectáreas Restauradas</div>
            </div>
          </div>
        </div>
        <div className="hero-actions">
          <button onClick={goToPlantTrees} className="btn btn-primary">
            Plantar un Árbol
          </button>
          <button onClick={scrollToAbout} className="btn btn-secondary">
            Saber Más
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
